<template>
  <b-modal
    id="my-account-modal"
    ref="modal"
    title="Mot de passe"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Enregistrer"
    cancel-title="Annuler"
  >

    <form ref="form" @submit.stop.prevent="handleSubmit">

      <!-- Old password -->
      <b-form-group
        label="Ancien mot de passe"
        label-for="oldPassword-input"
        :invalid-feedback="oldPassword.invalidFeedback"
        :state="oldPassword.state"
      >
        <b-form-input
          id="oldPassword-input"
          v-model="oldPassword.value"
          :state="oldPassword.state"
          type="password"
          autocomplete="off"
          required
        ></b-form-input>
      </b-form-group>

      <!-- New password -->
      <b-form-group
        label="Nouveau mot de passe"
        label-for="newPassword-input"
        :invalid-feedback="newPassword.invalidFeedback"
        :state="newPassword.state"
      >
        <b-form-input
          id="newPassword-input"
          v-model="newPassword.value"
          :state="newPassword.state"
          type="password"
          autocomplete="off"
          required
        ></b-form-input>
      </b-form-group>

      <!-- New password repeat -->
      <b-form-group
        label="Confirmer le nouveau mot de passe"
        label-for="newPasswordRepeat-input"
        :invalid-feedback="newPasswordRepeat.invalidFeedback"
        :state="newPasswordRepeat.state"
      >
        <b-form-input
          id="newPasswordRepeat-input"
          v-model="newPasswordRepeat.value"
          :state="newPasswordRepeat.state"
          type="password"
          autocomplete="off"
          required
        ></b-form-input>
      </b-form-group>

    </form>
  </b-modal>
</template>

<script>
import api from '../../services/api';
import {mapActions} from "vuex";

export default {

  name: 'my-account-modal',

  data: function () {
    return {
      oldPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPasswordRepeat: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  methods: {

    ...mapActions(["LogIn"]),

    resetModal() {
      this.oldPassword.value = null
      this.oldPassword.state = null
      this.oldPassword.invalidFeedback = null
      this.newPassword.value = null
      this.newPassword.state = null
      this.newPassword.invalidFeedback = null
      this.newPasswordRepeat.value = null
      this.newPasswordRepeat.state = null
      this.newPasswordRepeat.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('oldPassword', this.oldPassword.value.trim())
      formData.append('newPassword', this.newPassword.value.trim())
      formData.append('newPasswordRepeat', this.newPasswordRepeat.value.trim())

      api({
        method: 'POST',
        url: `/user/updateCurrentUserPassword`,
        data: formData
      })
        .then(response => {
          let data = {
            username: this.$store.getters.username,
            password: this.newPassword.value.trim()
          };

          this.LogIn(data);

          this.resetModal()
          this.hideModal()
          this.successToast()
        })
        .catch(error => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('my-account-modal')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
      }
      this.oldPassword.state = this.oldPassword.value != null && this.oldPassword.value.trim() !== ""
      this.oldPassword.invalidFeedback = 'Ce champ est requis'
      this.newPassword.state = this.newPassword.value != null && this.newPassword.value.trim() !== ""
      this.newPassword.invalidFeedback = 'Ce champ est requis'
      this.newPasswordRepeat.state = this.newPasswordRepeat.value != null && this.newPasswordRepeat.value.trim() !== ""
      this.newPasswordRepeat.invalidFeedback = 'Ce champ est requis'
      if (this.newPassword.state && this.newPasswordRepeat.state && this.newPassword.value !== this.newPasswordRepeat.value) {
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = 'Le nouveau mot de passe ne correspond pas'
        valid = false
      }
      return valid
    },

    successToast() {
      this.$bvToast.toast(`Mot de passe modifié`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    errorToast() {
      this.oldPassword.state = false
      this.oldPassword.invalidFeedback = 'Vérifiez ce champ'
      this.$bvToast.toast('Erreur lors de la modification du mot de passe. Vérifier l\'ancien mot de passe.', {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/user/MyAccountModal.vue